var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
export const PageHeader = (_a) => {
    var { align, className, description, kicker, title, titleAfter, right } = _a, other = __rest(_a, ["align", "className", "description", "kicker", "title", "titleAfter", "right"]);
    const componentClassName = classnames('sparky-c-page-header', className, {
        'sparky-c-page-header--center': align === 'center',
    });
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { children: [_jsxs("div", Object.assign({ className: "sparky-c-page-header__left" }, { children: [kicker && _jsx("p", Object.assign({ className: "sparky-c-page-header__kicker" }, { children: kicker })), _jsxs("h1", Object.assign({ className: "sparky-c-page-header__title" }, { children: [title, titleAfter && (_jsx("div", Object.assign({ className: "sparky-c-page-header__title-after" }, { children: titleAfter })))] })), description && (_jsx("div", Object.assign({ className: "sparky-c-page-header__description" }, { children: description })))] })), right && _jsx("div", Object.assign({ className: "sparky-c-page-header__right" }, { children: right }))] })));
};
//# sourceMappingURL=PageHeader.js.map